/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { Modal, Table } from 'antd';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as constant from '../../utils/constants';
import { ADMIN_USER_ID, TIME_FORMAT } from '../../utils/constants';
import './RoleUserModal.less';
import AddUserModal from './AddRoleUser';
import { Btn, OperateSpan } from '../Widgets';
import IconTip from '../IconTip';

class RoleUserModal extends PureComponent {
  static defaultProps = {
    visible: false,
    editRole: null,
    roleUsers: []
  };

  constructor() {
    super();
    this.state = {
      showAdd: false
    };
  }

  render() {
    const {
      visible,
      onCancel,
      roleUsers,
      editRole,
      intl,
      userInfo
    } = this.props;
    const { showAdd } = this.state;
    return (
      <Modal
        visible={visible}
        title={intl.formatMessage({ id: 'role_manage_user_list' })}
        onCancel={onCancel}
        wrapClassName="role-users-wrapper modal-close-header"
        footer={
          <Btn primary onClick={onCancel}>
            <FormattedMessage id="btn_close" />
          </Btn>
        }
        width={1024}
      >
        <div className="role-user">
          <div className="role-user-head">
            <Btn fontSize="13" onClick={this.toggleShowAdd}>
              <i className="iconfont icon-tianjia1" />
              <FormattedMessage id="re_add" />
            </Btn>
          </div>
          <div className="role-user-table">
            <Table
              columns={[
                {
                  title: intl.formatMessage({ id: 'role_manage_emp_name' }),
                  key: 'name',
                  width: '15%',
                  render: (text, record) => {
                    return record.firstName + record.givenName;
                  }
                },
                {
                  title: intl.formatMessage({ id: 'index_company' }),
                  key: 'company',
                  dataIndex: 'company',
                  width: '18%'
                },
                {
                  title: intl.formatMessage({ id: 'user_department' }),
                  key: 'dept',
                  dataIndex: 'dept',
                  width: '17%'
                },
                {
                  title: intl.formatMessage({ id: 'user_position' }),
                  key: 'position',
                  dataIndex: 'position',
                  width: '15%'
                },
                {
                  title: intl.formatMessage({ id: 'role_manage_time' }),
                  key: 'assignTime',
                  width: '20%',
                  render: (text, record) => {
                    return (
                      <div>
                        {record.assignTime
                          ? moment(record.assignTime).format(
                              TIME_FORMAT.date_time
                            )
                          : ''}
                      </div>
                    );
                  }
                },
                {
                  title: intl.formatMessage({ id: 'role_manage_operate' }),
                  key: 'action',
                  width: '15%',
                  render: (text, record) => {
                    if (record.userId === ADMIN_USER_ID) {
                      return null;
                    }
                    return (
                      <div>
                        {record.userId === userInfo.userId ? (
                          <OperateSpan>
                            <IconTip
                              disabled
                              title={intl.formatMessage({
                                id: 'role_manage_cant_del_your_self'
                              })}
                              type="shanchu"
                            />
                          </OperateSpan>
                        ) : (
                          <OperateSpan
                            onClick={this.deleteRoleUser.bind(this, record)}
                          >
                            <IconTip
                              title={intl.formatMessage({ id: 'user_delete' })}
                              type="shanchu"
                            />
                          </OperateSpan>
                        )}
                      </div>
                    );
                  }
                }
              ]}
              dataSource={roleUsers}
              rowKey={record => record.id}
              pagination={{
                total: roleUsers.length,
                pageSize: 5
              }}
            />
          </div>
        </div>
        <AddUserModal
          visible={showAdd}
          editRole={editRole}
          onCancel={this.toggleShowAdd}
        />
      </Modal>
    );
  }

  toggleShowAdd = () => {
    this.setState({ showAdd: !this.state.showAdd });
  };

  deleteRoleUser = user => {
    const { dispatch, intl } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'role_manage_delete_user_role' }),
      onOk: () => {
        if (user.roleKey === constant.ROLES_KEY.room_admin) {
          const promise = new Promise((resolve, reject) => {
            dispatch({
              type: 'role/checkRoomAdmin',
              userId: user.userId,
              resolve,
              reject
            });
          });
          promise.then(
            data => {
              if (data == 1) {
                Modal.error({
                  content: intl.formatMessage({
                    id: 'role_manage_delete_user_role_fail1'
                  })
                });
              } else {
                dispatch({
                  type: 'role/deleteRoleUser',
                  roleId: user.roleId,
                  userId: user.userId
                });
              }
            },
            msg => {
              console.log('------', msg);
            }
          );
        } else {
          dispatch({
            type: 'role/deleteRoleUser',
            roleId: user.roleId,
            userId: user.userId
          });
        }
      }
    });
  };
}

const mapStateToProps = state => {
  return {
    roleUsers: state.role.roleUsers,
    userInfo: state.login.userInfo
  };
};

export default connect(mapStateToProps)(injectIntl(RoleUserModal));



// WEBPACK FOOTER //
// ./src/components/account/RoleUserModal.js